<div class="company-info" [formGroup]="form">
  <div class="company-info-section-wrapper">
    <div class="company-info-container">
      <div class="company-info-section-title">
        {{ "company.general.general_data" | translate }}
        <span class="subtitle">{{
          "company.general.general_data_info" | translate
        }}</span>
      </div>
      <div class="company-info-section-name">
        <div class="company-info-section">
          <cowing-input [inputStyle]="EInputStyleType.Secondary" [isForm]="true"
            [placeholder]="'coworking.general.company-name' | translate" [control]="form.get('company_name')">
          </cowing-input>
        </div>
        <div class="company-info-section">
          <cowing-input [inputStyle]="EInputStyleType.Secondary" [isForm]="true"
            [placeholder]="'coworking.general.business-name' | translate" [control]="form.get('business_name')">
          </cowing-input>
        </div>
        <div class="company-info-section">
          <cowing-input [inputStyle]="EInputStyleType.Secondary" [isForm]="true"
            [placeholder]="'coworking.general.tax-id' | translate" [control]="form.get('tax_id')"></cowing-input>
        </div>
        <div class="company-info-section">
          <cowing-input-location *ngIf="(isEditingInfo && endGetInfo) || !isEditingInfo"
            [inputStyle]="EInputStyleType.Secondary" [isForm]="true"
            [placeholder]="'coworking.general.address' | translate" [control]="form.get('fiscal_address')"
            (setLocation)="setLocation($event)">
          </cowing-input-location>
        </div>
        <div class="company-info-section">
          <cowing-input-dropdown [inputStyle]="EInputStyleType.Secondary" [isForm]="true"
            [label]="'coworking.general.is-business-group' | translate" [control]="form.get('is_business_group')"
            [options]="[
              'coworking.general.yes' | translate,
              'coworking.general.no' | translate
            ]">
          </cowing-input-dropdown>
        </div>
        <div class="company-info-section">
          <cowing-input [inputStyle]="EInputStyleType.Secondary" [isForm]="true"
            [placeholder]="'coworking.general.group-name' | translate" [control]="form.get('business_group')">
          </cowing-input>
        </div>
        <div class="company-info-section">
          <cowing-input [inputStyle]="EInputStyleType.Secondary" [isForm]="true"
                        [placeholder]="'company.general.name' | translate" [control]="form.get('name')"></cowing-input>
        </div>
        <div class="company-info-section">
          <cowing-input [inputStyle]="EInputStyleType.Secondary" [isForm]="true"
                        [placeholder]="'company.general.phone' | translate" [control]="form.get('phone')"></cowing-input>
        </div>
        <div class="company-info-section">
          <cowing-input [inputStyle]="EInputStyleType.Secondary" [isForm]="true"
                        [placeholder]="'company.general.email' | translate" [control]="form.get('email')"></cowing-input>
        </div>
      </div>
    </div>

    <div class="company-info-container no-margin">
      <div class="company-info-section-title">
        {{ "coworking.general.time-open-title" | translate }}
      </div>
      <div class="company-info-section-name schedule-section">
        <div
                class="company-info-section-small"
                *ngFor="let day of daysOfWeek; let i = index"
                [attr.data-index]="i"
        >
          <cowing-timepicker
                  [inputStyle]="EInputStyleType.Secondary"
                  [isForm]="true"
                  [placeholder]="day"
                  [control]="form.get('schedule_open_' + (i + 1))"
                  [label]="day"
          >
          </cowing-timepicker>
        </div>
      </div>
    </div>
    <div class="company-info-container">
      <div class="company-info-section-title">
        {{ "coworking.general.time-close-title" | translate }}
      </div>
      <div class="company-info-section-name schedule-section">
        <div
                class="company-info-section-small"
                *ngFor="let day of daysOfWeek; let i = index"
                [attr.data-index]="i"
        >
          <cowing-timepicker
                  [inputStyle]="EInputStyleType.Secondary"
                  [isForm]="true"
                  [placeholder]="day"
                  [control]="form.get('schedule_close_' + (i + 1))"
                  [label]="day"
          >
          </cowing-timepicker>
        </div>
      </div>
    </div>
    <div class="company-info-container">
      <div class="company-info-section-title">
        {{ "coworking.general.media-title" | translate }}
        <span class="subtitle">
        {{ "coworking.general.video-optional" | translate }}
      </span>
      </div>
      <div class="company-info-section-name scrollable">
        <div class="company-info-section-media">
          <cowing-input-media
                  [isForm]="true"
                  [control]="form.get('video_1')"
                  [name]="'video_1'"
                  [acceptPhoto]="false"
          >
          </cowing-input-media>
        </div>
        <div class="company-info-section-media">
          <cowing-input-media
                  [isForm]="true"
                  [control]="form.get('photo_1')"
                  [name]="'photo_1'"
                  [acceptPhoto]="true"
          >
          </cowing-input-media>
        </div>
        <div class="company-info-section-media">
          <cowing-input-media
                  [isForm]="true"
                  [control]="form.get('photo_2')"
                  [name]="'photo_2'"
                  [acceptPhoto]="true"
          >
          </cowing-input-media>
        </div>
        <div class="company-info-section-media">
          <cowing-input-media
                  [isForm]="true"
                  [control]="form.get('photo_3')"
                  [name]="'photo_3'"
                  [acceptPhoto]="true"
          >
          </cowing-input-media>
        </div>
        <div class="company-info-section-media">
          <cowing-input-media
                  [isForm]="true"
                  [control]="form.get('photo_4')"
                  [name]="'photo_4'"
                  [acceptPhoto]="true"
          >
          </cowing-input-media>
        </div>
        <div class="company-info-section-media">
          <cowing-input-media
                  [isForm]="true"
                  [control]="form.get('photo_5')"
                  [name]="'photo_5'"
                  [acceptPhoto]="true"
          >
          </cowing-input-media>
        </div>
      </div>
    </div>
    <div class="company-info-container">
      <div class="company-info-section-title">
        {{ "coworking.general.description" | translate }}
        <span class="subtitle">
        {{ "coworking.general.max_chars_desc" | translate }}
      </span>
      </div>
      <div class="company-info-section-name">
        <div class="company-info-section-full">
          <cowing-textarea
                  [maxLength]="300"
                  [rows]="2"
                  [textareaStyle]="ETextareaStyleType.Primary"
                  [isForm]="true"
                  [control]="form.get('description')"
          >
          </cowing-textarea>
        </div>
      </div>
    </div>

  </div>
  <div *ngIf="isEditingInfo" class="actions-footer">
    <cowing-button [label]="'coworking.cancel' | translate" [type]="EButtonType.RoundedSecondary" [iconShow]="false"
      (event)="goBack()">
    </cowing-button>
    <cowing-button [disabled]="isDisabledForm" [label]="'company.general.save' | translate" [type]="EButtonType.Rounded"
      [iconShow]="false" (event)="editCompany()">
    </cowing-button>
  </div>
</div>
